import axios from 'axios'

import config from '../config'
import { SUPPORT_EMAIL } from '../constants'
import { requestProfile } from '../store/profile'
import { receiveErrorAlerts } from './alerts'
import { handleRequestError } from './request'

export const REQUEST_SUBSCRIPTION_PAYMENT = 'REQUEST_SUBSCRIPTION_PAYMENT'
export const CONFIRM_SUBSCRIPTION_PAYMENT = 'CONFIRM_SUBSCRIPTION_PAYMENT'
const CANCEL_SUBSCRIPTION = 'CANCEL_SUBSCRIPTION'

export const REQUEST_UPDATE_SUBSCRIPTION_TIER = 'REQUEST_UPDATE_SUBSCRIPTION_TIER'
export const RECEIVE_UPDATE_SUBSCRIPTION_TIER = 'RECEIVE_UPDATE_SUBSCRIPTION_TIER'

export const requestSubscriptionPayment = (subscriptionTierType) => (dispatch, getState) => {
    const { profile } = getState()
    const { id: userId } = profile

    const data = {
        redirectUrl: config.stripeSubscriptionCallbackUri,
        userId,
    }

    dispatch({ type: REQUEST_SUBSCRIPTION_PAYMENT, data })

    return axios
        .post('/subscriptions/subscriptionrequest', { ...data, subscriptionTierType, userId })
        .then((response) => {
            const sessionId = response?.data

            if (!sessionId) {
                dispatch(
                    receiveErrorAlerts(
                        `No se ha logrado encontrar el pago. Intenta nuevamente o contacta a ${SUPPORT_EMAIL}`
                    )
                )
                return Promise.reject()
            }

            return { sessionId }
        })
        .catch((error) => {
            dispatch(handleRequestError(error))
            return Promise.reject(error)
        })
}

export const confirmSubscriptionPayment = (data) => (dispatch) => {
    dispatch({ type: CONFIRM_SUBSCRIPTION_PAYMENT, data })

    const { sessionId } = data

    return axios
        .post(`/subscriptions/subscriptionconfirmation/${sessionId}`)
        .then((response) => {
            const { id, status } = response?.data || {}

            return { id, status }
        })
        .catch((error) => {
            dispatch(handleRequestError(error))
            return Promise.reject(error)
        })
}

export const cancelSubscription = (data) => (dispatch) => {
    dispatch({ type: CANCEL_SUBSCRIPTION, data })

    const { subscriptionId, cancellationReasonType, cancellationReasonDescription } = data

    return axios
        .put(`/subscriptions/${subscriptionId}`, {
            cancellationReasonType,
            cancellationReasonDescription,
        })
        .then(() => dispatch(requestProfile()))
        .catch((error) => {
            dispatch(handleRequestError(error))
            return Promise.reject(error)
        })
}

export const updateSubscriptionTier = (dispatch, data) => {
    dispatch({ type: REQUEST_UPDATE_SUBSCRIPTION_TIER, data })

    const { subscriptionId, subscriptionTierType } = data

    return axios
        .put(`/subscriptions/${subscriptionId}/tier`, {
            subscriptionTierType,
        })
        .then((response) => {
            dispatch({ type: RECEIVE_UPDATE_SUBSCRIPTION_TIER })
            return response.data
        })
        .catch((error) => {
            dispatch(handleRequestError(error))
            return { error }
        })
}
